import { RootState } from 'core/redux/types';

export function isReferralModalOpen(state: RootState): boolean {
    return state.referralModal.open;
}
